import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getSigmaReports } from "../app/util";
import { TILES } from "../app/config-v4-api";

export default function useDynamicTitle() {
    const { profile: { property_details } } = useSelector((state) => state.auth);
    const authAppState = useSelector(state => state);
    const { auth, app } = authAppState || {};
    const { current_state } = app || {};
    const { app_state, ui_state } = current_state || {};
    const { property_id, property_name } = app_state || {};

    const location = useLocation();
    let tiles = ui_state.active_tiles;//.map(tile => tile).join(",");
    let { segmented_view } = app_state.workspace_controls;
    let prop_name = " (" + property_name + ")";


    function getReportLabel() {
        const sigmaReportsArr = getSigmaReports(property_details, property_id);
        let reportId = sessionStorage.getItem('sigma_report_id');

        const report = sigmaReportsArr.find(r => r.id === reportId);
        return report ? report.label : ''; // returns null if not found
    }

    const getDataLevel = () => {
        const tiles = ui_state?.active_tiles || [];
        const { segmented_view, isRoomTypePricing, isRestrictionsRoomType, segmentType } = app_state?.workspace_controls || {};
        const mainTiles = ['otb', 'pickup', 'pace', 'forecast', "bi_sensitivity_analysis", "bi_pace_comparison", "bi_pickup_analysis"];

        if (tiles.some(tile => tile.toLowerCase() === "market") && tiles.length === 1) {
            return segmented_view ? "Segmented" : "";
        }

        // If active tile is one of the main tiles → return based on segmented_view
        if (tiles.some(tile => mainTiles.includes(tile.toLowerCase()))) {
            return segmented_view ? "Segmented" : "Hotel";
        }

        // If active tile is "flights" 
        if (tiles.some(tile => tile.toLowerCase().includes("flights") || tile.toLowerCase().includes("otb_v2_multi_segment")) && tiles.length === 1) {
            // return segmentType ? segmentType : "";
            // return segmentType ? segmentType.replace(/_/g, " ").replace(/\bmarket\b/gi, "").trim().replace(/^./, c => c.toUpperCase()) : "";
            return segmentType
                ? segmentType
                    .replace(/\btop_market_segment\b/gi, "Top Segments") // do this first
                    .replace(/_/g, " ")
                    .replace(/\bmarket\b/gi, "")
                    .replace(/\bsegment\b/gi, "Segmented")
                    .trim()
                    .replace(/^./, c => c.toUpperCase())
                : "";
        }

        if (tiles.some(tile => tile.toLowerCase() === "pricing") && tiles.length === 1) {
            return isRoomTypePricing ? "Room Type" : "Hotel";
        }

        // If active tile is "restriction" → check restriction type
        if (tiles.some(tile => tile.toLowerCase() === "restrictions") && tiles.length === 1) {
            if (isRestrictionsRoomType === true) return "Room Type";
            if (isRestrictionsRoomType === "product") return "Product";
            return "Hotel";
        }

        // Default fallback
        return "";
    };



    useEffect(() => {
        let mainTitle = "RM";
        // let numbersString = 'atuljohri-atuljohri-atuljohri-atuljohri-atuljohri-atuljohri-atuljohri-atuljohri-';
        //  document.title = numbersString;
        // tiles = tiles.replace(/[^a-zA-Z0-9_]/g, ""); 
        // tiles = tiles.replace(/_/g, " ");  
        // tiles = tiles.replace(/\b\w/g, (char) => char.toUpperCase());


        tiles = (tiles && tiles.length > 1) ? "Intellimerge" : TILES[tiles].title ? TILES[tiles].title : TILES[tiles].label;
        switch (location.pathname) {
            case "/settings":
                document.title = mainTitle + " - Setting - " + property_name;
                break;
            case "/events":
                document.title = mainTitle + " - Events - " + property_name;
                break;
            case "/groupIQ":
            case "/Group-IQ":
                mainTitle = "Group IQ";
                document.title = "Group IQ - " + property_name;
                break;
            case "/feeder-market-reports":
                document.title = "Feeder Market Insights - " + property_name;
                break;
            case "/analytics-reports":
                document.title = "AI - " + getReportLabel() + " - " + property_name;
                break;
            case "/lodgiq-user-guide":
                document.title = "LodgIQ User Guide - " + property_name;
                break;
            case "/login":
                debugger;
                document.title = mainTitle + " Login";
                break;
            default:
                let datalevel = getDataLevel();
                document.title = `${mainTitle} - ${tiles}${datalevel ? ' - ' + datalevel : ''}`;
        }
    }, [location, app_state]);
}
